export var LpInvestorUpdateStatus;
(function (LpInvestorUpdateStatus) {
    LpInvestorUpdateStatus["Draft"] = "draft";
    LpInvestorUpdateStatus["Published"] = "published";
})(LpInvestorUpdateStatus || (LpInvestorUpdateStatus = {}));
export var LpInvestorUpdateType;
(function (LpInvestorUpdateType) {
    LpInvestorUpdateType["BulletinUpdate"] = "bulletin-update";
    LpInvestorUpdateType["PeriodEndReport"] = "period-end-report";
})(LpInvestorUpdateType || (LpInvestorUpdateType = {}));
//# sourceMappingURL=index.js.map